import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

interface OAuthAuthUrlResponse {
    authUrl: string;
}

@Injectable({ providedIn: "root" })
export class OAuthLoginService {
    private readonly http = inject(HttpClient);

    private readonly resourceUrl: string = environment.apiUrl + "api";

    getMicrosoftAuthUrl(): Observable<OAuthAuthUrlResponse> {
        return this.http.get<OAuthAuthUrlResponse>(
            `${this.resourceUrl}/oauth/microsoft/auth-url`,
            {},
        );
    }
}
